
var sliderSplitPage = document.querySelector(".SplitSlide");

if (sliderSplitPage && sliderSplitPage.children.length > 0 && sliderSplitPage.parentNode && sliderSplitPage.parentNode.nodeType === 1) {
  try {
    var slider = tns({
      container: sliderSplitPage,
      items: 1,
      slideBy: 1,
      nav: false,
      controls: true,
      loop: false,
      mouseDrag: false,
      autoplay: false,
      gutter: 0
    });
  } catch (e) {
    console.error('Split slide page slider init error:', e);
  }
}
